// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v7.35.1
// source: odoo/order.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DateMessage, Money } from "./common";

export const protobufPackage = "pc.proto.odoo.order";

export enum AITariffType {
  AITARIFF_TYPE_A = 0,
  AITARIFF_TYPE_B = 1,
  AITARIFF_TYPE_C = 2,
  UNRECOGNIZED = -1,
}

export function aITariffTypeFromJSON(object: any): AITariffType {
  switch (object) {
    case 0:
    case "AITARIFF_TYPE_A":
      return AITariffType.AITARIFF_TYPE_A;
    case 1:
    case "AITARIFF_TYPE_B":
      return AITariffType.AITARIFF_TYPE_B;
    case 2:
    case "AITARIFF_TYPE_C":
      return AITariffType.AITARIFF_TYPE_C;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AITariffType.UNRECOGNIZED;
  }
}

export function aITariffTypeToJSON(object: AITariffType): string {
  switch (object) {
    case AITariffType.AITARIFF_TYPE_A:
      return "AITARIFF_TYPE_A";
    case AITariffType.AITARIFF_TYPE_B:
      return "AITARIFF_TYPE_B";
    case AITariffType.AITARIFF_TYPE_C:
      return "AITARIFF_TYPE_C";
    case AITariffType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ChangeAITariffOrder {
  tariffType: AITariffType;
  deliveryDate?: DateMessage | undefined;
}

export interface CreateOrderRequest {
  order?: { $case: "changeAiTariffOrder"; changeAiTariffOrder: ChangeAITariffOrder } | undefined;
  endcustomerInfo?: CreateOrderRequest_EndcustomerInformation | undefined;
}

export interface CreateOrderRequest_EndcustomerInformation {
  contactId: number;
}

export interface AITariff {
  tariffType: AITariffType;
  basePrice?: Money | undefined;
  overshootPrice?: Money | undefined;
  includedMinutes: number;
}

export interface GetAITariffProductsResponse {
  aiTariffs: AITariff[];
}

function createBaseChangeAITariffOrder(): ChangeAITariffOrder {
  return { tariffType: 0, deliveryDate: undefined };
}

export const ChangeAITariffOrder: MessageFns<ChangeAITariffOrder> = {
  encode(message: ChangeAITariffOrder, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tariffType !== 0) {
      writer.uint32(8).int32(message.tariffType);
    }
    if (message.deliveryDate !== undefined) {
      DateMessage.encode(message.deliveryDate, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChangeAITariffOrder {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChangeAITariffOrder();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tariffType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deliveryDate = DateMessage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChangeAITariffOrder {
    return {
      tariffType: isSet(object.tariffType) ? aITariffTypeFromJSON(object.tariffType) : 0,
      deliveryDate: isSet(object.deliveryDate) ? DateMessage.fromJSON(object.deliveryDate) : undefined,
    };
  },

  toJSON(message: ChangeAITariffOrder): unknown {
    const obj: any = {};
    if (message.tariffType !== 0) {
      obj.tariffType = aITariffTypeToJSON(message.tariffType);
    }
    if (message.deliveryDate !== undefined) {
      obj.deliveryDate = DateMessage.toJSON(message.deliveryDate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChangeAITariffOrder>, I>>(base?: I): ChangeAITariffOrder {
    return ChangeAITariffOrder.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChangeAITariffOrder>, I>>(object: I): ChangeAITariffOrder {
    const message = createBaseChangeAITariffOrder();
    message.tariffType = object.tariffType ?? 0;
    message.deliveryDate = (object.deliveryDate !== undefined && object.deliveryDate !== null)
      ? DateMessage.fromPartial(object.deliveryDate)
      : undefined;
    return message;
  },
};

function createBaseCreateOrderRequest(): CreateOrderRequest {
  return { order: undefined, endcustomerInfo: undefined };
}

export const CreateOrderRequest: MessageFns<CreateOrderRequest> = {
  encode(message: CreateOrderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.order?.$case) {
      case "changeAiTariffOrder":
        ChangeAITariffOrder.encode(message.order.changeAiTariffOrder, writer.uint32(10).fork()).join();
        break;
    }
    if (message.endcustomerInfo !== undefined) {
      CreateOrderRequest_EndcustomerInformation.encode(message.endcustomerInfo, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.order = {
            $case: "changeAiTariffOrder",
            changeAiTariffOrder: ChangeAITariffOrder.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endcustomerInfo = CreateOrderRequest_EndcustomerInformation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrderRequest {
    return {
      order: isSet(object.changeAiTariffOrder)
        ? {
          $case: "changeAiTariffOrder",
          changeAiTariffOrder: ChangeAITariffOrder.fromJSON(object.changeAiTariffOrder),
        }
        : undefined,
      endcustomerInfo: isSet(object.endcustomerInfo)
        ? CreateOrderRequest_EndcustomerInformation.fromJSON(object.endcustomerInfo)
        : undefined,
    };
  },

  toJSON(message: CreateOrderRequest): unknown {
    const obj: any = {};
    if (message.order?.$case === "changeAiTariffOrder") {
      obj.changeAiTariffOrder = ChangeAITariffOrder.toJSON(message.order.changeAiTariffOrder);
    }
    if (message.endcustomerInfo !== undefined) {
      obj.endcustomerInfo = CreateOrderRequest_EndcustomerInformation.toJSON(message.endcustomerInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRequest>, I>>(base?: I): CreateOrderRequest {
    return CreateOrderRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrderRequest>, I>>(object: I): CreateOrderRequest {
    const message = createBaseCreateOrderRequest();
    switch (object.order?.$case) {
      case "changeAiTariffOrder": {
        if (object.order?.changeAiTariffOrder !== undefined && object.order?.changeAiTariffOrder !== null) {
          message.order = {
            $case: "changeAiTariffOrder",
            changeAiTariffOrder: ChangeAITariffOrder.fromPartial(object.order.changeAiTariffOrder),
          };
        }
        break;
      }
    }
    message.endcustomerInfo = (object.endcustomerInfo !== undefined && object.endcustomerInfo !== null)
      ? CreateOrderRequest_EndcustomerInformation.fromPartial(object.endcustomerInfo)
      : undefined;
    return message;
  },
};

function createBaseCreateOrderRequest_EndcustomerInformation(): CreateOrderRequest_EndcustomerInformation {
  return { contactId: 0 };
}

export const CreateOrderRequest_EndcustomerInformation: MessageFns<CreateOrderRequest_EndcustomerInformation> = {
  encode(message: CreateOrderRequest_EndcustomerInformation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.contactId !== 0) {
      writer.uint32(8).int64(message.contactId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateOrderRequest_EndcustomerInformation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateOrderRequest_EndcustomerInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.contactId = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateOrderRequest_EndcustomerInformation {
    return { contactId: isSet(object.contactId) ? globalThis.Number(object.contactId) : 0 };
  },

  toJSON(message: CreateOrderRequest_EndcustomerInformation): unknown {
    const obj: any = {};
    if (message.contactId !== 0) {
      obj.contactId = Math.round(message.contactId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRequest_EndcustomerInformation>, I>>(
    base?: I,
  ): CreateOrderRequest_EndcustomerInformation {
    return CreateOrderRequest_EndcustomerInformation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateOrderRequest_EndcustomerInformation>, I>>(
    object: I,
  ): CreateOrderRequest_EndcustomerInformation {
    const message = createBaseCreateOrderRequest_EndcustomerInformation();
    message.contactId = object.contactId ?? 0;
    return message;
  },
};

function createBaseAITariff(): AITariff {
  return { tariffType: 0, basePrice: undefined, overshootPrice: undefined, includedMinutes: 0 };
}

export const AITariff: MessageFns<AITariff> = {
  encode(message: AITariff, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tariffType !== 0) {
      writer.uint32(8).int32(message.tariffType);
    }
    if (message.basePrice !== undefined) {
      Money.encode(message.basePrice, writer.uint32(18).fork()).join();
    }
    if (message.overshootPrice !== undefined) {
      Money.encode(message.overshootPrice, writer.uint32(26).fork()).join();
    }
    if (message.includedMinutes !== 0) {
      writer.uint32(32).int64(message.includedMinutes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AITariff {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAITariff();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.tariffType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.basePrice = Money.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.overshootPrice = Money.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includedMinutes = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AITariff {
    return {
      tariffType: isSet(object.tariffType) ? aITariffTypeFromJSON(object.tariffType) : 0,
      basePrice: isSet(object.basePrice) ? Money.fromJSON(object.basePrice) : undefined,
      overshootPrice: isSet(object.overshootPrice) ? Money.fromJSON(object.overshootPrice) : undefined,
      includedMinutes: isSet(object.includedMinutes) ? globalThis.Number(object.includedMinutes) : 0,
    };
  },

  toJSON(message: AITariff): unknown {
    const obj: any = {};
    if (message.tariffType !== 0) {
      obj.tariffType = aITariffTypeToJSON(message.tariffType);
    }
    if (message.basePrice !== undefined) {
      obj.basePrice = Money.toJSON(message.basePrice);
    }
    if (message.overshootPrice !== undefined) {
      obj.overshootPrice = Money.toJSON(message.overshootPrice);
    }
    if (message.includedMinutes !== 0) {
      obj.includedMinutes = Math.round(message.includedMinutes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AITariff>, I>>(base?: I): AITariff {
    return AITariff.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AITariff>, I>>(object: I): AITariff {
    const message = createBaseAITariff();
    message.tariffType = object.tariffType ?? 0;
    message.basePrice = (object.basePrice !== undefined && object.basePrice !== null)
      ? Money.fromPartial(object.basePrice)
      : undefined;
    message.overshootPrice = (object.overshootPrice !== undefined && object.overshootPrice !== null)
      ? Money.fromPartial(object.overshootPrice)
      : undefined;
    message.includedMinutes = object.includedMinutes ?? 0;
    return message;
  },
};

function createBaseGetAITariffProductsResponse(): GetAITariffProductsResponse {
  return { aiTariffs: [] };
}

export const GetAITariffProductsResponse: MessageFns<GetAITariffProductsResponse> = {
  encode(message: GetAITariffProductsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.aiTariffs) {
      AITariff.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAITariffProductsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAITariffProductsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.aiTariffs.push(AITariff.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAITariffProductsResponse {
    return {
      aiTariffs: globalThis.Array.isArray(object?.aiTariffs)
        ? object.aiTariffs.map((e: any) => AITariff.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAITariffProductsResponse): unknown {
    const obj: any = {};
    if (message.aiTariffs?.length) {
      obj.aiTariffs = message.aiTariffs.map((e) => AITariff.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAITariffProductsResponse>, I>>(base?: I): GetAITariffProductsResponse {
    return GetAITariffProductsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAITariffProductsResponse>, I>>(object: I): GetAITariffProductsResponse {
    const message = createBaseGetAITariffProductsResponse();
    message.aiTariffs = object.aiTariffs?.map((e) => AITariff.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
